import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'se-product-management-ui-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',

  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  title = 'Commerce';
  loading = true;

  onActivate(__event: Event) {
    this.loading = false;
  }

  onDeactivate(__event: Event) {
    this.loading = true;
  }
}
